import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { fetchConfigurationAudit } from '../../../actions/configurations';

interface UseConfigurationAuditProps {
    isOpen: boolean;
    tenantId: string;
    configKeyname?: string;
}

export const useConfigurationAudit = ({
                                          isOpen,
                                          tenantId,
                                          configKeyname
                                      }: UseConfigurationAuditProps) => {
    const [pageNumber, setPageNumber] = useState(1);
    const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();

    // Get audit history from Redux store
    const configurationAuditData = useSelector(
        (state: CMx.ApplicationState) =>
            state.configurations.configurationAuditHistory
    );

    // Fetch audit history when drawer opens
    useEffect(() => {
        if (isOpen && tenantId && configKeyname) {
            dispatch(
                fetchConfigurationAudit({
                    tenantId,
                    pageNumber: pageNumber || 1,
                    pageSize: 10,
                    searchKey: configKeyname
                })
            );
        }
    }, [isOpen, tenantId, configKeyname, pageNumber, dispatch]);

    // Handle page change for pagination of audit data
    const handlePageChange = (newPageNumber: number) => {
        if (newPageNumber !== pageNumber) {
            setPageNumber(newPageNumber);
        }
    };

    return {
        configurationAuditData,
        handlePageChange,
        pageNumber
    };
};